import styled from 'styled-components';
import { display } from 'styled-system';

import { flexBasis, maxWidth, offset, gutter } from './system';
import { ResponsiveValue } from '../../types';

export const Container = styled.div<{
  span: number | number[];
  offset?: ResponsiveValue;
  gutter?: ResponsiveValue;
  display?: string | string[];
}>`
  display: block;
  box-sizing: border-box;
  ${flexBasis};
  ${maxWidth};
  ${offset};
  ${gutter};
  ${display};
`;
